export const getSmtpConfiguration = (state) => state.smtp
